// extracted by mini-css-extract-plugin
export default {"label":"MenuIcon_label__kOlKB"};